import { render, staticRenderFns } from "./SVGS.vue?vue&type=template&id=3f44b664&scoped=true&"
import script from "./SVGS.vue?vue&type=script&lang=js&"
export * from "./SVGS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f44b664",
  null
  
)

export default component.exports